<template>
    <div class="page">
        <v-container class="py-3 py-lg-6">
            <v-card :class="{'py-2 px-3 bordered': pcOnly}" flat>
                <v-card-title :class="{'px-2': phoneOnly}">عن المنصة</v-card-title>
                <v-card-subtitle :class="{'px-2': phoneOnly}">اعرف معلومات أكثر عن المنصة</v-card-subtitle>
                <v-card-text :class="{'px-2': phoneOnly}">
                    <p class="strong-text--text medium-text" style="white-space: pre-line; line-height: 2">
                        {{appData.about_platform}}
                    </p>
                </v-card-text>
            </v-card>
        </v-container>

        <slot v-if="!isAuthed" name="footer" />
    </div>
</template>
<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
    }
}
</script>